export default __webpack_public_path__ + "static/ScotlandslittleknownHighlanders-603bf46652b0b27d14fa6f597ebfb022.jpg";